import { gql } from '@apollo/client'

const GET_NONPROFIT_ORG_TEAM_QUERY = gql`
  query NonprofitOrgTeam($nonprofitOrgId: Int!, $planName: String!) {
    nonprofitOrgTeam(nonprofitOrgId: $nonprofitOrgId, planName: $planName) {
      users {
        nonprofitOrgId
        lastInviteSentAt
        role
        nonprofitOrgRole
        userId
        user {
          firstName
          lastName
          id
          email
          createdAt
          updatedAt
        }
      }
      limits {
        visible
        limit
        used
        available
        lowestPlanTier
      }
    }
  }
`

export default GET_NONPROFIT_ORG_TEAM_QUERY
